module.exports = __webpack_public_path__ + "img/compentation_service.f423b0e9.svg";